/* @flow */

import axios from 'axios';
import Promise from 'bluebird';

import { logout } from '../modules/auth/actions';
import { LYSTER_API_ENDPOINT } from '../env';
import { authorizationHeaderSelector, isLoggedInSelector } from '../modules/auth/selectors';
import { handleSessionExpiry } from '../modules/navigation/actions';
import pusher from '../utils/pusher';
import NetworkError from './NetworkError';


const lysterClient = axios.create({
  baseURL: LYSTER_API_ENDPOINT,
  timeout: 10000,
});

const connectToStore = (store: Object) => {
  lysterClient.interceptors.request.use((config) => {
    const headers = config.headers || {},
          pusherSocketId = pusher.connection && pusher.connection.socket_id;

    return {
      ...config,
      headers: {
        ...headers,
        pusherSocketId,
        Authorization: headers.Authorization || authorizationHeaderSelector(store.getState()),
      },
    };
  });

  lysterClient.interceptors.response.use(undefined, (error: any) => {
    const { response } = error,
          state = store.getState();
    if (
      response
      && response.status === 401
      && isLoggedInSelector(state)
      && error.config.headers.Authorization
        === authorizationHeaderSelector(state)
      && error.config.url.indexOf('/logup') === -1
    ) {
      store.dispatch(handleSessionExpiry());

      store.dispatch(logout());
    }

    return Promise.reject(new NetworkError(error.message));
  });

  return lysterClient;
};

export { connectToStore };

export default lysterClient;
